/* eslint-disable react/no-array-index-key */
import React from 'react';

import Heading from 'Components/Heading/Heading';
import Common from '../Common/Common';
import operationsBrain from '../../Assets/elvotaimages/operations_brain.png';
import riskImage from '../../Assets/elvotaimages/operations_risk_management.png';
import allways247 from '../../Assets/elvotaimages/operations_247.png';
import bgImage from '../../Assets/elvotaimages/Group100.png';

export default function OperationalServices() {
  const contentValues = [
    {
      heading: 'Market Signal Layer',
      paragraph: [
        '- Real time AI predictions of electricity prices, loads, and generation',
        '- Location and asset specific dispatch instructions',
      ],
      imageSrc: operationsBrain,
    },
    {
      heading: 'Strategic Layer',
      paragraph:
      [
        '- Adaptive bidding algorithms, multi-market and multi-products trading execution logic',
        '- Capture opportunistic revenue from abnormal market conditions',
      ],
    },
    {
      heading: 'Risk Layer',
      paragraph:
      [
        '- Predefined exposure limit',
        '- Drawdown control and anomaly safeguards',
      ],
      imageSrc: riskImage,
    },
    {
      heading: 'Operational Layer',
      paragraph:
      [
        '- Internal tools for strategic real time monitoring and risk control measures',
        '- Internal tools for structured feedback and continuous improvement',
      ],
      imageSrc: allways247,
    },
  ];
  
  return (
    <div>
      <Heading content="Energy storage trading intelligence" />
      <div className="pb-[40px]">
        <div className="custom-paragraph space-y-4">
          <p>
            Evolta provides a fully managed energy trading service, combining proprietary trading intelligence with strategic Energy Management.
          </p>
          <p>
            Whether operating as your dedicated trading partner or collaborating with your in-house trading team, Evolta adapts to your preferred level of involvement, enabling shared strategic oversight, customized trading strategies and direct control when needed.
          </p>
          <h3 className="font-semibold">Bespoke Algorithmic Trading</h3>
          <p>
            Beyond configurable strategies, Evolta can develop customer-specific changes to its proprietary trading algorithms, adapting trading behavior to specialized commercial objectives, market views and asset requirements.
          </p>
        </div>
        <p className="custom-paragraph mt-4">
          With this approach, Evolta empowers energy storage operators to navigate complexity confidently while unlocking sustainable value.
        </p>
      </div>
      <div
        className="relative z-0" // Make sure the div is positioned relatively
        style={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: 'contain', // Ensure the image is fully contained within the section
          backgroundPosition: 'center', // Center the image
          backgroundRepeat: 'no-repeat', // Prevent image from repeating
          padding: '40px 0', // Add padding for spacing
        }}
      >
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-12 lg:gap-16">
          {contentValues.map((value, index) => (
            <div key={index} className="flex h-full">
              <Common
                heading={value.heading}
                paragraph={value.paragraph}
                imageSrc={value.imageSrc}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
